import { getJaneGoldFAQPath, getJaneGoldLandingPath } from '@iheartjane/menu';
import { Link } from '@iheartjane/reefer';
import { useState } from 'react';

import qrPng from '@jane/kiosk/pages/assets/qr-logo.png';

import { Modal } from '../Modal';
import { QRCodeCallout } from '../QRCodeCallout/QRCodeCallout';

export const LearnMoreLink = ({
  userHasLinkedBank,
}: {
  userHasLinkedBank?: boolean;
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <Link onClick={() => setModalOpen(true)} color="primary">
        Learn more
      </Link>
      {modalOpen && (
        <Modal
          appId="root"
          contentLabel="Jane Gold Learn More"
          onRequestClose={() => setModalOpen(false)}
          open
          overlayClose
          variant="dialogue"
        >
          <Modal.Content padding={false}>
            <QRCodeCallout
              type="jane-gold"
              buttonLabel="Go back"
              onClick={() => setModalOpen(false)}
              qrCode={qrPng}
              url={
                userHasLinkedBank
                  ? getJaneGoldFAQPath()
                  : getJaneGoldLandingPath()
              }
            />
          </Modal.Content>
        </Modal>
      )}
    </>
  );
};
